import React from 'react';
import { ListInvoicesMerchantTableSubscriptionFee } from 'types/InvoicesMerchantDetails';
import { formatDollar, formatPercent } from 'utils';
import { ItemSalesReport } from './ItemSalesReport.style';

const CardInvoicesMerchantTable = ({
  type,
  qty,
  unitPriceHT,
  discount,
  totalHT,
  vat,
  vatAmount,
  totalTTC
}: ListInvoicesMerchantTableSubscriptionFee) => {
  return (
    <ItemSalesReport>
      <td>{type}</td>
      <td>{qty}</td>
      <td>{unitPriceHT ? `${formatDollar(unitPriceHT)} €` : null}</td>
      <td>{discount ? `${formatPercent(String(discount * 100))} %` : '0%'}</td>
      <td>{totalHT ? `${formatDollar(totalHT)} €` : null}</td>
      <td>{vat ? `${formatPercent(String(vat * 100))} %` : null}</td>
      <td>{vatAmount ? `${formatDollar(vatAmount)} €` : null}</td>
      <td>{totalTTC ? `${formatDollar(totalTTC)} €` : null}</td>
    </ItemSalesReport>
  );
};

export default CardInvoicesMerchantTable;
